import React from "react";
// #region types
import { CurrencyEnums } from "models/enums";
import { TableCellCurrencyFormatterProps } from "models/propTypes/simpleTableProps";
//#endregion
//#region component
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const CurrencyValueFormatter: React.FC<TableCellCurrencyFormatterProps> = ({ cellValue, sumValue }) => {
  const sumInSEK = typeof sumValue === "number" ? sumValue : sumValue?.value;

  const getMainValue = () => {
    const mainValue = sumInSEK ?? cellValue?.find((element) => element.type === CurrencyEnums.CurrencyCode.SEK)?.value;
    return LocalizationHelperInstance.getFormattedCurrency(mainValue ?? 0, CurrencyEnums.CurrencyCode.SEK, 2, 2);
  };

  const getSubValue = () => {
    const subValues: string[] = [];

    if (cellValue?.length === 1 && cellValue[0].type === CurrencyEnums.CurrencyCode.SEK) {
      return [];
    }

    cellValue?.forEach((element) => {
      if (sumInSEK !== undefined || element.type !== CurrencyEnums.CurrencyCode.SEK) {
        subValues.push(LocalizationHelperInstance.getFormattedCurrency(element.value, element.type, 2, 2));
      }
    });
    return subValues;
  };

  return (
    <Grid container className={cssExports.currencyValue}>
      <Grid container className={cssExports.mainValue}>
        {getMainValue()}
      </Grid>
      <Grid container className={cssExports.subValue}>
        {getSubValue().map((value, index) => (
          <Grid item key={index} xs={12}>
            {value}
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default CurrencyValueFormatter;
